import { lazy } from 'react';
import paths from '../paths';
import { createLazyComponent, createRoute } from 'constants/utils';
const Triggers = lazy(() => import('../../components/pages/campaign/editCampaign/downsells/triggers/Triggers'));
const Products = lazy(() => import('../../components/pages/campaign/editCampaign/downsells/products/Products'));
const Mappings = lazy(() => import('../../components/pages/campaign/editCampaign/downsells/mappings/Mappings'));
const AddProduct = lazy(() => import('../../components/pages/campaign/editCampaign/downsells/products/AddProduct/AddProduct'));
const CampaignEditLayout = lazy(() => import('../../components/pages/campaign/editCampaign/CampaignEditLayout'));
const CampaignAffiliates = lazy(() => import('../../components/pages/campaign/editCampaign/affiliate/CampaignAffiliates'));
const CampaignCountries = lazy(() => import('../../components/pages/campaign/editCampaign/campaignCountries/CampaignCountries'));
const CampaignFulFilment = lazy(() => import('../../components/pages/campaign/editCampaign/campaignFulFilment/CampaignFulFilment'));
const AddEmail = lazy(() => import('../../components/pages/campaign/editCampaign/email/AddEmail/AddEmail'));
const Emails = lazy(() => import('../../components/pages/campaign/editCampaign/email/Emails'));
const AddGeneralDetails = lazy(() => import('../../components/pages/campaign/editCampaign/generalDetail/AddGeneralDetails'));
const Offers = lazy(() => import('../../components/pages/campaign/editCampaign/offer/Offers'));
const AddOffer = lazy(() => import('../../components/pages/campaign/editCampaign/offer/AddOffer/AddOffer'));
const AddUpsell = lazy(() => import('../../components/pages/campaign/editCampaign/upsell/AddUpsell/AddUpsell'));
const AddBadBinUpsell = lazy(() => import('../../components/pages/campaign/editCampaign/upsell/AddBadBinUpsell/AddBadBinUpsell'));
const Upsells = lazy(() => import('../../components/pages/campaign/editCampaign/upsell/Upsells/Upsells'));
const Downsells = lazy(() => import('../../components/pages/campaign/editCampaign/downsells/Downsells'));
const Pixels = lazy(() => import('../../components/pages/campaign/editCampaign/pixels/Pixels'));
const AddPixels = lazy(() => import('../../components/pages/campaign/editCampaign/pixels/AddPixel/AddPixel'));
const Pages = lazy(() => import('../../components/pages/campaign/pages/Pages'));
const AddPage = lazy(() => import('../../components/pages/campaign/pages/AddPage/AddPage'));

export const campaignEditRoutes = (abilities) => {

  return {
    path: paths.getCampaignEditLayout(),
    element: createLazyComponent(CampaignEditLayout),
    children: [
      (abilities?.campaign?.write ?? false) && createRoute(paths.editCampaign(), AddGeneralDetails),
      (abilities?.campaign?.read ?? false) && createRoute(paths.countries(), CampaignCountries),
      (abilities?.campaign?.read ?? false) && createRoute(paths.offers(), Offers),
      (abilities?.campaign?.write ?? false) && createRoute(paths.newOffer(), AddOffer),
      (abilities?.campaign?.write ?? false) && createRoute(paths.editOffer(), AddOffer),
      (abilities?.campaign?.read ?? false) && createRoute(paths.upsells(), Upsells),
      (abilities?.campaign?.read ?? false) && {
        path: paths.downsells(),
        element: createLazyComponent(Downsells),
        children: [
          { path: 'triggers', element: createLazyComponent(Triggers) },
          { path: 'products', element: createLazyComponent(Products) },
          { path: 'products/new', element: createLazyComponent(AddProduct) },
          { path: 'products/:productId/edit', element: createLazyComponent(AddProduct) },
          { path: 'mappings', element: createLazyComponent(Mappings) },
        ],
      },
      (abilities?.campaign?.read ?? false) && createRoute(paths.campaignAffiliates(), CampaignAffiliates),
      (abilities?.campaign?.read ?? false) && createRoute(paths.fulfilments(), CampaignFulFilment),
      (abilities?.campaign?.read ?? false) && createRoute(paths.emails(), Emails),
      (abilities?.campaign?.write ?? false) && createRoute(paths.newUpsell(), AddUpsell),
      (abilities?.campaign?.write ?? false) && createRoute(paths.editUpsell(), AddUpsell),
      (abilities?.campaign?.write ?? false) && createRoute(paths.newBadBinUpsell(), AddBadBinUpsell),
      (abilities?.campaign?.write ?? false) && createRoute(paths.editBadBinUpsell(), AddBadBinUpsell),
      (abilities?.campaign?.write ?? false) && createRoute(paths.newEmail(), AddEmail),
      (abilities?.campaign?.write ?? false) && createRoute(paths.editEmail(), AddEmail),
      (abilities?.campaign?.read ?? false) && createRoute(paths.campaingPixels(), Pixels),
      (abilities?.campaign?.read ?? false) && createRoute(paths.newCampaignPixel(), AddPixels),
      (abilities?.campaign?.read ?? false) && createRoute(paths.editCampaignPixel(), AddPixels),
      (abilities?.campaign?.read ?? false) && createRoute(paths.campaignPages(), Pages),
      (abilities?.campaign?.read ?? false) && createRoute(paths.newCampaignPage(), AddPage),
      (abilities?.campaign?.read ?? false) && createRoute(paths.editCampaignPage(), AddPage),
    ],
  };
};
